import Cleon1 from '../../../Media/Residential/Cleon Apart/Cleon (1).webp'
import Cleon2 from '../../../Media/Residential/Cleon Apart/Cleon (2).webp'


const Cleonmages =[
Cleon1,Cleon2
]

export default Cleonmages;